module.exports = __webpack_public_path__ + "static/media/premierOneRightSeatSelected.bd150eb5.svg";